import { useEffect, useState } from "react";
import ReactPlayer from "react-player/lazy";
import { generateQrCode } from '../api/qrcode';
import { front_url, tokenId } from "../config/constant";
import { sendDataToApp } from "../utils/android";
import { getItem, setItem } from "../utils/storage";
import { trans } from "../utils/utilsTrans";

const InitContentScreen = ({ translations, isApp, isDemo, previewConfig }) => {
  const [image, setImage] = useState(null);
  const id = getItem(tokenId);
  const isMTKFireTV = /AFT/.test(navigator.userAgent);

  useEffect(() => {
    generateQrCode()
      .then((response) => setImage(response))
      .catch(_ => {})
    ;
  }, []);

  return (
    <div className={`init_screen ${window.innerWidth < window.innerHeight ? 'vertical' : 'horizontal'}`}>
      {!isApp ? (
        <ReactPlayer
          className='hidden-video'
          url='/public/muted-blank.mp4'
          playing={true}
          width={10}
          height={10}
          muted={true}
          loop={true}
          config={{
            file: {
              hlsOptions: isMTKFireTV
                ? {
                    capLevelToPlayerSize: true,
                    startLevel: 2,
                    autoStartLoad: true,
                    abrEwmaDefaultEstimate: 500000,
                  }
                : {},
              dashOptions: isMTKFireTV
                ? {
                    streaming: {
                      abr: {
                        autoSwitchBitrate: { video: false },
                        initialBitrate: { video: 1500 },
                      },
                    },
                  }
                : {},
            },
          }}
        />
      ) : null}
      <img src='/public/images/logo/clap.png' className='logo' onLoad={() => sendDataToApp("ready")} alt="" />
      <h1 className='init-title'>{trans('association.title', translations)}</h1>
      <div className='flex'>
        <section>
          <div>
            <div className='icon-text'>
              <i className='ic-smartphone-2' />
              <span>{trans('association.first_method.title', translations)}</span>
            </div>
            <p>{trans('association.first_method.text', translations)}</p>
          </div>
          {image ? (<img src={`data:image;base64,${image}`} alt="" />) : null}
        </section>
        <div className='separator'>
          <div className='line' />
          <span>{trans('association.or', translations)}</span>
          <div className='line' />
        </div>
        <section>
          <div className='flex-col'>
            <div className='icon-text'>
              <i className='ic-screen' />
              <span>{trans('association.second_method.title', translations)}</span>
            </div>
            <p>{trans('association.second_method.text', translations)}</p>
            <div className='code-container'>
              <span>{trans('association.second_method.code_label', translations)}</span>
              <p className='token'>{id}</p>
            </div>
          </div>
        </section>
      </div>
      <div className='need-help'>
        {trans('association.need_help', translations)} <a href={`${front_url}/help`}>{`${front_url}/help`}</a>
      </div>
    </div>
  )
}

export default InitContentScreen;
